"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientsReportApi = void 0;
const createApi_1 = require("../../../helpers/createApi");
const getReport = (caller) => ({ accountIdentifier, ...otherParams }) => {
    return caller(`clients/${accountIdentifier}/report`).get({ ...otherParams });
};
const postReport = (caller) => ({ accountIdentifier, ...otherParams }) => {
    return caller(`clients/${accountIdentifier}/report`).post({ ...otherParams });
};
const deleteReport = (caller) => ({ accountIdentifier, ...otherParams }) => {
    return caller(`clients/${accountIdentifier}/report`).delete({ ...otherParams });
};
exports.clientsReportApi = (0, createApi_1.createAPIFactory)({
    getReport,
    postReport,
    deleteReport,
});
//# sourceMappingURL=api.js.map